import React, { useState, useEffect } from 'react';
import { bool, array, func, object } from 'prop-types';
import MenuItem from './MenuItem';
import withMenu from './withMenu';
import { MenuContainer, Backdrop } from './Menu.css';

const Menu = ({
  mobile = false,
  setMobileMenuVisible,
  items,
  location,
  tabletMenuVisible,
  closeTabletMenu
}) => {
  const [active, setActive] = useState({});
  const [showSub, setShowSub] = useState(false);
  const closeSubmenu = () => setShowSub(false);
  // for iPad to force closing when location changes
  useEffect(() => {
    closeTabletMenu && closeTabletMenu();
    closeSubmenu();
  }, [location]);

  const renderItems = item =>
    item &&
    item.display && (
      <MenuItem
        key={item.title}
        data-qa={item.qa}
        mobile={mobile}
        showSubMenu={!mobile && active.title === item.title && showSub}
        active={!mobile && active.title === item.title}
        tabletMenuVisible={tabletMenuVisible}
        onClick={() => {
          // avoid override closeSubmenu function on click
          if (item.subItems) setShowSub(true);
          if (active.title !== item.title) {
            setActive(item);
            if (mobile && !item.subItems) {
              setMobileMenuVisible(false);
            }
          }

          // close mobile top menu when link is the same
          if (mobile && location.pathname === item.url) {
            setMobileMenuVisible(false);
          }
        }}
        closeSubmenu={closeSubmenu}
        {...item}
      />
    );

  return items && items.length > 0 ? (
    <MenuContainer data-qa="dashboard-grid">
      {mobile && showSub && (
        <MenuItem
          title={active.title}
          header
          data-qa={active.qa}
          onClick={() => {
            setShowSub(false);
            closeSubmenu();
          }}
        >
          {active.subItems && (
            <ul>
              {active.subItems.map(subItem => (
                <MenuItem
                  key={subItem.title}
                  data-qa={subItem.qa}
                  simple
                  {...subItem}
                  // close menu on mobile
                  onClick={() => setMobileMenuVisible(false)}
                />
              ))}
            </ul>
          )}
        </MenuItem>
      )}

      {mobile && !showSub && items && items.map(renderItems)}
      {!mobile && items && items.map(renderItems)}

      <Backdrop
        active={tabletMenuVisible}
        onClickOutside={() => {
          closeTabletMenu();
          closeSubmenu();
        }}
      />
    </MenuContainer>
  ) : null;
};

Menu.propTypes = {
  mobile: bool,
  partsBrands: array,
  setMobileMenuVisible: func,
  match: object,
  items: array,
  tabletMenuVisible: bool,
  closeTabletMenu: func,
  // from `TopNavigation`
  location: object
};

export default withMenu(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js